(function () {
  function initSharePopup() {
    const popup = document.querySelector('.share_popup_maim_container.custom_popup');
    const shareBtn = document.querySelector('.share-btn');
    if (!popup || !shareBtn) return;

    // Escape product-section stacking contexts so trust cards can't cover the modal
    if (popup.parentElement !== document.body) {
      document.body.appendChild(popup);
    }

    shareBtn.addEventListener('click', () => {
      popup.classList.add('show');
      document.documentElement.classList.add('myd-share-open');
    });

    const closeBtn = popup.querySelector('.custom_popup_close');
    const close = () => {
      popup.classList.remove('show');
      document.documentElement.classList.remove('myd-share-open');
    };

    closeBtn?.addEventListener('click', close);
    popup.addEventListener('click', (e) => {
      if (e.target === popup || e.target.classList.contains('share_popup_main')) close();
    });

    popup.querySelectorAll('.click_to_copy').forEach((element) => {
      element.addEventListener('click', () => {
        const url = element.getAttribute('data-url') || window.location.href;
        if (navigator.clipboard?.writeText) {
          navigator.clipboard.writeText(url);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSharePopup);
  } else {
    initSharePopup();
  }
})();
